import { BaseModel } from '../../../models/base-model'
import { AnswerChoiceGroup } from '../'

export class Label extends BaseModel {
  public key: string = ''
  public value: string = ''
  public answerChoiceGroup: AnswerChoiceGroup
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/models/label/label.ts